import { useState } from "react";

export function useNotificacoes() {
  const [notifs, setNotifs] = useState([]);
  const adicionar = (lead, de, para) => {
    const cores = { fechado:"#10b981", perdido:"#ef4444", proposta:"#8b5cf6", reuniao:"#3b82f6", contato:"#f59e0b", prospeccao:"#6366f1" };
    const n = { id: Date.now(), lead: lead.nome, de, para, color: cores[para]||"#FF6B2B" };
    setNotifs(prev => [n, ...prev.slice(0,9)]);
    setTimeout(() => setNotifs(prev => prev.filter(x => x.id !== n.id)), 5000);
  };
  const limpar = (id) => setNotifs(prev => prev.filter(x => x.id !== id));
  return { notifs, adicionar, limpar };
}

export function NotificacaoToast({ notifs, limpar }) {
  return (
    <div style={{ position:"fixed", bottom:28, right:28, zIndex:2000, display:"flex", flexDirection:"column", gap:10, maxWidth:320 }}>
      {notifs.map(n => (
        <div key={n.id} style={{ background:"#2C2C2F", border:`1px solid ${n.color}44`, borderLeft:`4px solid ${n.color}`, borderRadius:14, padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, boxShadow:"0 8px 32px rgba(0,0,0,.5)" }}>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:"#F2F2F7", marginBottom:3 }}>Lead movido</div>
            <div style={{ fontSize:12, color:"#8E8E93" }}><span style={{ color:"#F2F2F7", fontWeight:500 }}>{n.lead}</span> → <span style={{ color:n.color, fontWeight:600 }}>{n.para}</span></div>
          </div>
          <button onClick={()=>limpar(n.id)} style={{ background:"none", border:"none", color:"#8E8E93", fontSize:18, cursor:"pointer", padding:0 }}>×</button>
        </div>
      ))}
    </div>
  );
}
